module.exports = __webpack_public_path__ + "80c3ca7960d5c41a963763261ecdd32a.svg";